import { createSdkApollo } from "@daytrip/graphql-client-utils";

import type { Requester } from "../types/generated/graphql-sdk";
import { getSdk } from "../types/generated/graphql-sdk";

export type Sdk = ReturnType<typeof getSdk>;

export const getSdkApollo = createSdkApollo<Requester, Sdk>(getSdk);
